import { useScreenSize } from '@Hooks/useScreenSize';
import { useEffect } from 'react';
import { useDimensions } from 'react-native-web-hooks';

import { useScreenSizeStore } from './ScreenSizeStore';

export const ScreenSizeSpy = () => {
  const { setSize, setWindowWidth, window: storeWindow } = useScreenSizeStore();
  const { window } = useDimensions();

  const [size, windowWidth] = useScreenSize();

  useEffect(() => {
    storeWindow.set(window);
  }, [window]);

  useEffect(() => {
    setSize(size);
  }, [size]);

  useEffect(() => {
    setWindowWidth(windowWidth);
  }, [windowWidth]);

  return null;
};
